<div class="form-group">
  @if (formReady) {
    <form [formGroup]="form">
      <app-custom-input
        [customFormGroup]="form"
        [id]="'mandateHolderFirstname'"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.FIRSTNAME' | translate)"
        [attr.data-cy]="testIdPrefix + 'mandateHolderFirstname'">
      </app-custom-input>
      <app-custom-input
        [customFormGroup]="form"
        [id]="'mandateHolderLastname'"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.LASTNAME' | translate)"
        [attr.data-cy]="testIdPrefix + 'mandateHolderLastname'">
      </app-custom-input>
      <app-custom-input
        id="mandateHolderDateOfBirth"
        type="date"
        [customFormGroup]="form"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.DATE_OF_BIRTH' | translate)"
        data-content="dd.mm.yyyy"
        [attr.data-cy]="testIdPrefix + 'mandateHolderDateOfBirth'">
      </app-custom-input>
      <app-custom-input
        [customFormGroup]="form"
        [id]="'mandateHolderStreet'"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.STREET' | translate)"
        [attr.data-cy]="testIdPrefix + 'mandateHolderStreet'">
      </app-custom-input>
      <app-custom-input
        [customFormGroup]="form"
        [id]="'mandateHolderPostalCode'"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.POSTAL_CODE' | translate)"
        [pattern]="getPlzPattern('mandateHolderCountry')"
        [maxlength]="getMaxPlzLength('mandateHolderCountry')"
        [attr.data-cy]="testIdPrefix + 'mandateHolderPostalCode'">
      </app-custom-input>
      <app-custom-input
        [customFormGroup]="form"
        [id]="'mandateHolderCity'"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.CITY' | translate)"
        [attr.data-cy]="testIdPrefix + 'mandateHolderCity'">
      </app-custom-input>
      <app-custom-select
        id="mandateHolderCountry"
        [class]="'sfk-ellipsed-ng-select'"
        [customFormGroup]="form"
        [items]="countryList"
        [multiple]="false"
        [clearable]="false"
        bindLabel="value"
        bindValue="name"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.COUNTRY' | translate)"
        [attr.data-cy]="testIdPrefix + 'mandateHolderCountry'"
        (onchange)="setPlzPatternValidator('mandateHolderPostalCode', 'mandateHolderCountry')">
      </app-custom-select>
      <app-custom-input
        [customFormGroup]="form"
        [id]="'mandateHolderBankName'"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.BANK_NAME' | translate)"
        [attr.data-cy]="testIdPrefix + 'mandateHolderBankName'">
      </app-custom-input>
      <app-custom-input
        [customFormGroup]="form"
        [id]="'mandateHolderIban'"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.IBAN' | translate)"
        [attr.data-cy]="testIdPrefix + 'mandateHolderIban'">
      </app-custom-input>
      <app-custom-input
        [customFormGroup]="form"
        [id]="'mandateHolderBic'"
        [label]="bicRequiredMarker + ('TICKETS.MANDATE_HOLDER_INFORMATION.BIC' | translate)"
        [attr.data-cy]="testIdPrefix + 'mandateHolderBic'">
      </app-custom-input>
      <app-custom-checkbox
        [id]="'mandateHolderSepaMandateAccepted'"
        [customFormGroup]="form"
        [label]="PFLICHTFELDMARKER + ('TICKETS.MANDATE_HOLDER_INFORMATION.SEPA_MANDATE_ACCEPTED' | translate)"
        [title]="'TICKETS.MANDATE_HOLDER_INFORMATION.SEPA_MANDATE_TITLE' | translate">
      </app-custom-checkbox>
    </form>
  }
</div>
